if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        const variantIdInput = this.variantIdInput;

        if (variantIdInput) {
          variantIdInput.disabled = false;
        }

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton =
          this.querySelector('[type="submit"]');

        this.submitButtonText =
          this.submitButton.querySelector(
            '.venat-add-to-bag-text'
          ) ||
          this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute(
            'aria-haspopup',
            'dialog'
          );
        }

        this.hideErrors =
          this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (
          this.submitButton.getAttribute(
            'aria-disabled'
          ) === 'true' ||
          this.submitButton.disabled
        ) {
          return;
        }

        this.handleErrorMessage();

        this.error = false;

        this.submitButton.setAttribute(
          'aria-disabled',
          'true'
        );

        this.submitButton.classList.add(
          'loading'
        );

        const spinner =
          this.querySelector(
            '.loading__spinner'
          );

        if (spinner) {
          spinner.classList.remove('hidden');
        }

        const config =
          fetchConfig('javascript');

        config.headers['X-Requested-With'] =
          'XMLHttpRequest';

        delete config.headers['Content-Type'];

        const formData =
          new FormData(this.form);

        const variantId =
          formData.get('id');

        const quantity =
          parseInt(
            formData.get('quantity')
          ) || 1;

        // Ask Shopify to return the cart drawer + cart icon in the SAME
        // add-to-cart request. This avoids extra /cart.js and full-page cart fetches.
        if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id).join(',')
          );
          formData.append('sections_url', window.location.pathname);
        }

        config.body = formData;

        const linesUpdateDeferred =
          this.createCartLinesUpdateEvent(
            variantId,
            quantity
          );

        fetch(
          window.routes.cart_add_url,
          config
        )
          .then((response) => {
            if (!response.ok) {
              throw new Error(
                'Cart request failed'
              );
            }

            return response.json();
          })

          .then((response) => {
            if (response.status) {
              this.error = true;

              const message =
                response.description ||
                response.message ||
                window.cartStrings.error;

              this.handleErrorMessage(
                message
              );

              this.dispatchCartErrorEvent(
                message,
                'INVALID'
              );

              linesUpdateDeferred?.reject(
                new Error(message)
              );

              return;
            }

            this.resolveCartLinesUpdate(
              linesUpdateDeferred
            );

            // Render Shopify's returned sections immediately. No second network request.
            if (this.cart && typeof this.cart.renderContents === 'function' && response.sections) {
              this.cart.renderContents(response);
            }

            publish(
              PUB_SUB_EVENTS.cartUpdate,
              {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              }
            );
          })

          .then(() => {
            if (this.error) {
              return;
            }

            const textSpan =
              this.submitButton.querySelector(
                '.venat-add-to-bag-text'
              );

            if (textSpan) {
              textSpan.textContent =
                'ADDED TO BAG';
            }

            this.submitButton.classList.add(
              'venat-bag-button--added'
            );

            clearTimeout(
              this.submitButton
                .__venatResetTimer
            );

            this.submitButton
              .__venatResetTimer =
              setTimeout(() => {
                if (textSpan) {
                  textSpan.textContent =
                    'ADD TO BAG';
                }

                this.submitButton.classList.remove(
                  'venat-bag-button--added'
                );
              }, 2500);

          })

          .catch((error) => {
            console.error(
              'VÉNAT Add to Bag error:',
              error
            );

            this.error = true;

            this.handleErrorMessage(
              error.message ||
                window.cartStrings.error
            );

            this.dispatchCartErrorEvent(
              error.message ||
                window.cartStrings.error,
              'SERVICE_UNAVAILABLE'
            );

            linesUpdateDeferred?.reject(
              error
            );
          })

          .finally(() => {
            this.submitButton.classList.remove(
              'loading'
            );

            this.submitButton.removeAttribute(
              'aria-disabled'
            );

            if (spinner) {
              spinner.classList.add('hidden');
            }

            if (!this.error) {
              this.submitButton.disabled =
                false;
            }

            CartPerformance.measureFromEvent(
              'add:user-action',
              evt
            );
          });
      }

      /*
       * Uppdaterar siffran på korgikonen direkt.
       */
      updateCartCount() {
        return fetch(
          `${window.routes.cart_url}.json`,
          {
            credentials: 'same-origin',
            cache: 'no-store',
          }
        )
          .then((response) => {
            if (!response.ok) {
              throw new Error(
                'Could not get cart'
              );
            }

            return response.json();
          })

          .then((cart) => {
            const cartIcon =
              document.querySelector(
                '#cart-icon-bubble'
              );

            if (!cartIcon) {
              return;
            }

            /*
             * Leta efter den befintliga
             * cart-count-bubblan.
             */
            let count =
              cartIcon.querySelector(
                '.cart-count-bubble'
              );

            /*
             * Om Shopify inte har någon bubble
             * skapar vi den.
             */
            if (cart.item_count > 0) {
              if (!count) {
                count =
                  document.createElement(
                    'div'
                  );

                count.className =
                  'cart-count-bubble';

                cartIcon.appendChild(
                  count
                );
              }

              count.innerHTML =
                '<span aria-hidden="true">' +
                cart.item_count +
                '</span>' +
                '<span class="visually-hidden">' +
                cart.item_count +
                ' items' +
                '</span>';

              count.removeAttribute(
                'hidden'
              );
            } else if (count) {
              count.remove();
            }

            /*
             * Uppdatera aria-label om den finns.
             */
            if (cart.item_count > 0) {
              cartIcon.setAttribute(
                'aria-label',
                'Cart (' +
                  cart.item_count +
                  ')'
              );
            } else {
              cartIcon.setAttribute(
                'aria-label',
                'Cart'
              );
            }
          })

          .catch((error) => {
            console.error(
              'VÉNAT cart count error:',
              error
            );
          });
      }

      /*
       * Uppdaterar cart drawer.
       */
      refreshCartDrawer(parsedState) {
        const cartDrawer =
          document.querySelector(
            'cart-drawer'
          );

        if (!cartDrawer) {
          return Promise.resolve();
        }

        return fetch(
          window.routes.cart_url,
          {
            credentials: 'same-origin',
            cache: 'no-store',
          }
        )
          .then((response) => {
            if (!response.ok) {
              throw new Error(
                'Could not load cart'
              );
            }

            return response.text();
          })

          .then((htmlText) => {
            const parser =
              new DOMParser();

            const html =
              parser.parseFromString(
                htmlText,
                'text/html'
              );

            const newDrawer =
              html.querySelector(
                'cart-drawer'
              );

            if (!newDrawer) {
              return;
            }

            const currentInner =
              cartDrawer.querySelector(
                '.drawer__inner'
              );

            const newInner =
              newDrawer.querySelector(
                '.drawer__inner'
              );

            if (
              currentInner &&
              newInner
            ) {
              currentInner.innerHTML =
                newInner.innerHTML;
            }

            cartDrawer.classList.toggle(
              'is-empty',
              newDrawer.classList.contains(
                'is-empty'
              )
            );

            const overlay =
              cartDrawer.querySelector(
                '#CartDrawer-Overlay'
              );

            if (overlay) {
              overlay.addEventListener(
                'click',
                () =>
                  cartDrawer.close()
              );
            }
          })

          .catch((error) => {
            console.error(
              'VÉNAT cart drawer update error:',
              error
            );
          });
      }

      handleErrorMessage(
        errorMessage = false
      ) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper) {
          return;
        }

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (
          errorMessage &&
          this.errorMessage
        ) {
          this.errorMessage.textContent =
            errorMessage;
        }
      }

      toggleSubmitButton(
        disable = true,
        text
      ) {
        if (disable) {
          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );

          if (
            text &&
            this.submitButtonText
          ) {
            this.submitButtonText.textContent =
              text;
          }
        } else {
          this.submitButton.removeAttribute(
            'disabled'
          );

          if (this.submitButtonText) {
            this.submitButtonText.textContent =
              'ADD TO BAG';
          }
        }
      }

      createCartLinesUpdateEvent(
        variantId,
        quantity
      ) {
        const {
          CartLinesUpdateEvent,
        } = window.StandardEvents || {};

        if (!CartLinesUpdateEvent) {
          return null;
        }

        const deferred =
          CartLinesUpdateEvent.createPromise();

        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [
              {
                merchandiseId: variantId,
                quantity: quantity,
              },
            ],
            promise: deferred.promise,
          })
        );

        return deferred;
      }

      resolveCartLinesUpdate(
        deferred
      ) {
        if (!deferred) return;

        const {
          CartLinesUpdateEvent,
        } = window.StandardEvents || {};

        if (!CartLinesUpdateEvent) {
          return;
        }

        const pendingCartDataPromise =
          typeof CartItems !==
          'undefined'
            ? CartItems.fetchCartData()
            : fetch(
                `${window.routes.cart_url}.json`
              ).then(
                (response) =>
                  response.json()
              );

        pendingCartDataPromise
          .then((cart) => {
            if (!cart?.currency) {
              deferred.reject(
                new Error(
                  'Missing currency in cart response'
                )
              );

              return;
            }

            deferred.resolve({
              cart:
                CartLinesUpdateEvent.createCartFromAjaxResponse(
                  cart
                ),
            });
          })
          .catch((error) => {
            deferred.reject(error);
          });
      }

      dispatchCartErrorEvent(
        message,
        code
      ) {
        const {
          CartErrorEvent,
        } = window.StandardEvents || {};

        if (!CartErrorEvent) return;

        this.dispatchEvent(
          new CartErrorEvent({
            error: message,
            code: code,
          })
        );
      }

      get variantIdInput() {
        return this.form.querySelector(
          '[name="id"]'
        );
      }
    }
  );
}
